import { push } from 'connected-react-router';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { call, put, all, takeEvery } from 'redux-saga/effects';

import api from '../../services/api';
import { Types } from '../ducks/userSauce';

export function* requestUserSaga(payload) {
  try {
    const response = yield call(api.fetchUser, payload.data);
    if (_.isArray(response.data)) {
      yield put({
        type: Types.FETCH_USER_SUCCESS,
        data: response.data,
      });
    } else {
      yield put({
        type: Types.FETCH_USER_ID_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({ type: Types.FETCH_USER_FAILURE });
  }
}
export function* requestUserByClientSaga(payload) {
  try {
    const response = yield call(
      api.fetchUserByClient,
      `?id_clients=${JSON.stringify(payload.data)}`
    );
    yield put({
      type: Types.FETCH_USER_BY_CLIENT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({ type: Types.FETCH_USER_FAILURE });
  }
}

export function* updateUserSaga(payload) {
  try {
    yield call(api.updateUser, payload.data);
    yield put({
      type: Types.FETCH_USER_REQUEST,
    });
    toast.success('Atualizado com sucesso!');
    yield put(push('/user'));
  } catch (error) {
    yield put({ type: Types.FETCH_USER_FAILURE });
    toast.error('Ocorreu um error!');
  }
}

export function* createUserSaga(payload) {
  try {
    yield call(api.createUser, payload.data);
    yield put({
      type: Types.FETCH_USER_REQUEST,
    });
    toast.success('Usuário cadastrado com sucesso!');
    yield put(push('/user'));
  } catch (error) {
    yield put({ type: Types.FETCH_USER_FAILURE });
    switch (error.response.data.errors[0].message) {
      case 'email must be unique':
        toast.warning('E-mail não pode ser duplicado');

        break;
      case 'cpf must be unique':
        toast.warning('CPF não pode ser duplicado');

        break;

      default:
        toast.warning('Erro ao cadastrar o usuário');

        break;
    }
    // console.log();
  }
}

export default function* rootSaga() {
  yield all([takeEvery(Types.FETCH_USER_REQUEST, requestUserSaga)]);
  yield all([
    takeEvery(Types.FETCH_USER_BY_CLIENT_REQUEST, requestUserByClientSaga),
  ]);
  yield all([takeEvery(Types.UPDATE_USER_REQUEST, updateUserSaga)]);
  yield all([takeEvery(Types.CREATE_USER_REQUEST, createUserSaga)]);
}
